import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ActionModal } from '@companio/companio_ui';

type LockData = {
  annual_report_id?: string;
  year?: number;
  message?: string;
};

export const AR_LOCK_EVENT = 'ar-lock';

export function AnnualReportLockModal() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [lockData, setLockData] = useState<LockData | null>(null);

  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<LockData>).detail;
      setLockData(detail || null);
      setIsOpen(true);
    };
    window.addEventListener(AR_LOCK_EVENT, handler);
    return () => window.removeEventListener(AR_LOCK_EVENT, handler);
  }, []);

  const close = () => {
    setIsOpen(false);
    setLockData(null);
  };

  const goToAr = () => {
    if (lockData?.annual_report_id) {
      navigate(`/annual_report/${lockData.annual_report_id}/missing_documents_for_transactions`);
    }
    close();
  };

  const description =
    lockData?.message || t('transaction_locked_by_annual_report', { year: lockData?.year });

  return (
    <ActionModal
      isOpen={isOpen}
      modalType="confirmation"
      clickOutside={close}
      title={t('transaction_locked_by_annual_report_title')}
      description={description}
      firstButton={{
        text: t('cancel'),
        onClick: close,
        variant: 'gray'
      }}
      secondButton={{
        text: t('go_to_annual_report'),
        onClick: goToAr,
        variant: 'primary'
      }}
      modalWidth="512px"
    />
  );
}
